const n = [
  "https://polygonscan.com/"
], c = "0x89", o = "Polygon Mainnet", r = {
  decimals: 18,
  name: "MATIC",
  symbol: "MATIC"
}, a = [
  "https://polygon-rpc.com/"
], s = {
  blockExplorerUrls: n,
  chainId: c,
  chainName: o,
  nativeCurrency: r,
  rpcUrls: a
};
export {
  n as blockExplorerUrls,
  c as chainId,
  o as chainName,
  s as default,
  r as nativeCurrency,
  a as rpcUrls
};
//# sourceMappingURL=network-mainnet.json.js.map
